import React from 'react';
import { Card as AntCard } from 'antd-v5';
import styled, { useTheme } from 'styled-components';
import { Flex, FlexJustifyType, MarginBox, Text } from 'UI';
import { BreakpointSelectable } from 'utils';

export interface CustomCardProps {
  children?: React.ReactNode;
  title: React.ReactNode;
  noPadding?: boolean;
  justify?: BreakpointSelectable<FlexJustifyType>;
  'data-cy'?: string;
}

export const DarkCard = ({ children, title, noPadding, justify, 'data-cy': dataCy }: CustomCardProps) => {
  return (
    <Card
      isDark={true}
      title={
        <Flex justify={justify ?? 'center'}>
          <Text type={'card_title_dark'} data-cy={dataCy} disableGutter>
            {title}
          </Text>
        </Flex>
      }
      noPadding={noPadding}
    >
      {children}
    </Card>
  );
};

export const LightCard = ({ children, title, 'data-cy': dataCy }: CustomCardProps) => {
  return (
    <SLightCard
      title={
        <Flex>
          <Text type={'card_title_light'} data-cy={dataCy} disableGutter>
            {title}
          </Text>
        </Flex>
      }
    >
      {children}
    </SLightCard>
  );
};

interface SCardProps {
  background: string;
  $noPadding?: boolean;
}

const SCard = styled(AntCard)<SCardProps>`
  height: 100%;
  box-shadow: 0 4px 10px 0 ${({ theme }) => theme.color.shadow_2};

  .ant5-card-head,
  .ant-card-head {
    height: 60px;
    background-color: ${({ background }) => background};
  }

  .ant5-card-body,
  .ant-card-body {
    padding: ${({ $noPadding }) => ($noPadding ? 0 + 'px' : '')};
  }
`;

const SLightCard = styled(AntCard)`
  height: 100%;
  background-color: ${({ theme }) => theme.color.grey_brown} !important;

  .ant-card-head {
    padding: 10px 12px 5px 12px;
    margin: 0;
    background: none;
    min-height: 0;

    .ant-card-head-wrapper {
      .ant-card-head-title {
        padding: 0px;
      }
    }
  }

  .ant-card-body {
    border-top: 0;
    padding: 5px 12px 12px 12px;
  }
`;

interface CardProps {
  children?: React.ReactNode;
  title: React.ReactNode;
  isDark: boolean;
  noPadding?: boolean;
}

const Card = ({ children, isDark, title, noPadding = false }: CardProps) => {
  const theme = useTheme();
  const backgroundCol = isDark ? theme.color.grey00 : theme.color.grey95;

  return (
    <SCard background={backgroundCol} $noPadding={noPadding} title={<MarginBox ml={10}>{title}</MarginBox>}>
      {children}
    </SCard>
  );
};
